export enum GiftType {
  SignupBonus = 1, // bonus when player make first deposit
  DepositBonus = 2, // bonus related to deposit
  RakeBack = 3, // bonus give as Rakeback
  ReferAFriendRegister = 4, // the player who register using a refer a friend bonus
  ReferAFriendReferrer = 5, // the player who invited a friend | SatelliteToken, token to play a satellite
}

export enum GiftName {
  "Signup Bonus" = 1,
  "Deposit Bonus" = 2,
  "Rake Back" = 3,
  "Refer A Friend Register" = 4,
  "Refer A Friend Referrer" = 5,
}
